<template>
  <v-card flat :id="dialog_id" style="margin-top:0">
    <v-card-text style="margin-top:0">
      <v-layout row wrap style="margin-top:0">
        <v-flex xs12 style="text-align:center">
          <!-- <v-icon>delete_all</v-icon> -->
          <slot name="shop-info"></slot>
        </v-flex>
        <v-flex xs12>
          <slot name="item-list"></slot>
        </v-flex>
        <v-flex xs12>
          <slot name="cost-summary"></slot>
        </v-flex>
        <v-flex xs12 style="margin-top:10px">
          <slot name="payment-info"></slot>
        </v-flex>
        <v-flex xs12 style="margin-top:10px">
          <slot name="customer-info"></slot>
        </v-flex>
        <v-flex xs12 style="margin-top:10px;text-align:center">
          <slot name="tu-note"></slot>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn icon @click="print()" class="noprint">
        <v-icon>print</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
@media print{
  .noprint{
    display: none;
  }
}
</style>
<script>
'use strict'
export default {
  props:{
    dialog_id:{
      type:String,
    }
  },
  methods: {
    print() {
      //window.print();

      // Get HTML to print from element
      const prtHtml = document.getElementById(this.dialog_id).innerHTML;

 

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }



      var toPrint = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

     //window.ipcRenderer.send('print-data', toPrint);
      WinPrint.document.title = "Transaction Receipt";
      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    }
  }
};
</script>